<template>
    <section class="inner" v-if="accordion">
        <div class="accordion-block">
            <h2 v-if="accordion.title" class="block-title" v-html="accordion.title"></h2>
        </div>
        <div class="list">
            <div class="item" v-for="(item, index) in accordion.accordion" :key="index">
                <h3 class="title" :class="{'actived': item.actived}" v-html="item.title + '<span>↓</span>'" @click="item.actived = !item.actived"></h3>
                <slide-up-down :active="item.actived" :duration="300">
                    <Content v-html="item.content">
                    </Content>
                </slide-up-down>
            </div>
        </div>

    </section>
</template>

<script>
import Content from '@/components/ui/Content.vue';

export default {
    name: 'accordion-block',

    data() {
        return {
            accordion: false,
        }
    },

    props: {
        data: {
            type: Object,
            default: {},
        },
    },

    components: {
        Content,
    },

    mounted() {
        let list = JSON.parse(JSON.stringify(this.data));
        list.accordion.forEach(item => {
            item.actived = false;
        });

        this.accordion = list;
    },

}
</script>

<style lang="scss" scoped>
    .accordion-block {
        padding: 0 12rem var(--padding);
        // margin-bottom: var(--padding-x2);

        .block-title {
            padding: 0 0 var(--padding);
            font-size: var(--medium-size);
            line-height: 1;
        }

    }

    .list {

        .title {
            padding-right: 5rem;
            position: relative;
            cursor: pointer;
            margin-bottom: var(--padding-50);
            overflow: hidden;

            span {
                position: absolute;
                right: 0;
                top: 0;
                transform: rotate(0deg);
                transition: transform .2s ease;
            }

            &.actived span {
                transform: rotate(-180deg);
            }
        }

        .item {
            overflow: hidden;
        }

        .ui-enter {
            overflow: hidden;
            padding-bottom: var(--padding);

            *:last-child {
                margin-bottom: 0;
            }
            
        }
    }

    @media only screen and (max-width: 767px) {
        .list {
            padding: 0 var(--padding);
        }
    }


</style>
